// extracted by mini-css-extract-plugin
export default {"button":"Xp-z","reviewSort":"Yp-z"};